export function LiveSendAction(sessionId, contentId, pageIndex, invitationToken, actionMetadataMicroapp) {
    const me = this;
    me.SessionId = sessionId;
    me.ContentId = contentId;
    me.PageIndex = pageIndex;
    me.InvitationToken = invitationToken;

    if (actionMetadataMicroapp) {
        me.IsMicroapp = true;
        me.ActionMetadataMicroapp = actionMetadataMicroapp;
    }
}

export function DownloadAction(contentId) {
    const me = this;
    me.ContentId = contentId;
}
